export function parseCalendarDate(value: string | Date): Date {
  if (value instanceof Date) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }

  const match = /^(\d{4})-(\d{2})-(\d{2})(?:$|[T ])/.exec(value);

  if (!match) {
    return new Date(NaN);
  }

  const year = Number(match[1]);
  const month = Number(match[2]) - 1;
  const day = Number(match[3]);
  const date = new Date(year, month, day);

  return date.getFullYear() === year &&
    date.getMonth() === month &&
    date.getDate() === day
    ? date
    : new Date(NaN);
}

export function isValidCalendarDate(value?: Date): value is Date {
  return value instanceof Date && !Number.isNaN(value.getTime());
}

export function getCalendarDateKey(value: Date): string {
  const year = value.getFullYear().toString().padStart(4, "0");
  const month = (value.getMonth() + 1).toString().padStart(2, "0");
  const day = value.getDate().toString().padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function setCalendarDateYear(value: Date, year: number): Date {
  const month = value.getMonth();
  const day = Math.min(value.getDate(), new Date(year, month + 1, 0).getDate());

  return new Date(year, month, day);
}
